module.exports = __webpack_public_path__ + "static/about-top-image-72a51f238bceb30dbebff78b7284e89a.jpg";